<div class="rewards-root" *transloco="let t">
  <app-header>{{ t('region-rewards') }}</app-header>
  <div class="filter-container">
    <app-filter-container
      (selectFilterClick)="updateFilter($event)"
      [baseSimpleChipData]="chipContents"
      [sortOptions]="this.sortOptions"
      [seriesChips]="this.seriesChips"
      [filters]="this.filters"
    ></app-filter-container>
    <app-region-selector></app-region-selector>
  </div>
  <div *ngIf="isEmpty && !loadingRewards" class="empty-list">
    <app-empty-feed
      icon="list_alt"
      header="{{ t('rewards-empty') }}"
      text="{{ t('feed-not-listed-description') }}"
    >
    </app-empty-feed>
  </div>
  <div
    *ngIf="!isEmpty || loadingRewards"
    class="rewards-list"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    [scrollWindow]="false"
    [immediateCheck]="true"
    (scrolled)="pullRewards()"
  >
    <app-reward-card
      *ngFor="let reward of rewards"
      [reward]="reward"
      (removeReward)="removeReward($event)"
      [showDefaultImage]="!reward.imgSource"
      (cardClick)="onRewardClick($event)"
      [isRewardScreen]="true"
    ></app-reward-card>
    <div class="loading-more-items">
      <mat-spinner *ngIf="loadingRewards"></mat-spinner>
    </div>
  </div>
  
  <div class="add-reward" *ngIf="authenticatedUserService.isGlobalAdmin()">
    <app-icon-button
      icon="add_circle_outline"
      v2="true"
      (clickAction)="goToRewardAddReward()"
    >
      {{ addRewardLabel | transloco }}</app-icon-button
    >
  </div>
</div>
